import Network from './Network';

class DowntimeService {
	static async getSubscribers() {
		let response = await Network.request({
			method: 'GET',
			url: '/admin/downtime/list',
		});
		return response.data;
	}

	static async notifyAll(message) {
		const body = message ? { message } : {};
		let response = await Network.request({
			method: 'POST',
			url: '/admin/downtime/notify',
			data: body,
		});
		return response.data;
	}
}

export default DowntimeService;
